import React from 'react';
import { FiFilter } from '@react-icons/all-files/fi/FiFilter';
import { Wrapper, ButtonStyle } from './RiskFilterButtonStyle';
import { useDispatch, useSelector } from 'react-redux';
import { pushShowCard, pushCancelEvent, pushChipArray, pushSearchChipArray, setSearchString } from '../../../slices/RiskFilterSlice';
import { pushShowApply, pushRestrictValue } from '../../../slices/ButtonsSlice';
import ExportToExcel from './ExportToExcel';
import styled from 'styled-components';
const StyledFiFilter = styled(FiFilter)`
  color: ${props => !props.showApply && !props.restrictValue && !props.applyEvent ? '#212121' : '#0461A7'};
`;
const StyledSpan = styled.span`
  display: inline-block;
  margin-left: 3px !important;
  margin-top: 1px !important;
  color: ${props => !props.showApply && !props.restrictValue && !props.applyEvent ? '#212121' : '#0461A7'};
`;

const RiskFilter = props => {
  const dispatch = useDispatch();
  const showApply = useSelector(state => state.buttonSlice.showApply);
  const applyEvent = useSelector(state => state.riskFilterSlice.applyEvent);
  const restrictValue = useSelector(state => state.buttonSlice.restrictValue);
  const clickEvent = useSelector(state => state.applicationDrillHeatMap.clickEvent);
  const showCard = useSelector(state => state.riskFilterSlice.showCard);
  const riskExportApi = useSelector(state => state.apiUrl.riskApi);
  const riskExportFilterApi = useSelector(state => state.apiUrl.filterRiskApi);
  const riskReqBody = useSelector(state => state.riskFilterSlice.riskReqBody);
  const accountRiskReqBody = useSelector(state => state.riskFilterSlice.accountRiskReqBody);
  var d = new Date();
  let year = d.getFullYear();
  let month = d.getMonth() + 1;
  let date = d.getDate();
  var dateVal = year + '-' + month + '-' + date;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(ButtonStyle, {
    onClick: () => {
      dispatch(pushShowCard(true));
      dispatch(pushShowApply(true));
      dispatch(pushRestrictValue(true));
      dispatch(pushCancelEvent(false));
      dispatch(pushChipArray([]));
      dispatch(pushSearchChipArray([]));
      dispatch(setSearchString(''));
    }
  }, /*#__PURE__*/React.createElement(StyledFiFilter, {
    showApply: showApply,
    restrictValue: restrictValue,
    applyEvent: applyEvent
  }), /*#__PURE__*/React.createElement(StyledSpan, {
    showApply: showApply,
    restrictValue: restrictValue,
    applyEvent: applyEvent
  }, "Filter")), !showCard && /*#__PURE__*/React.createElement(ExportToExcel, {
    apiUrl: applyEvent ? riskExportFilterApi : riskExportApi,
    apiRequestBody: clickEvent ? accountRiskReqBody : riskReqBody,
    totalCount: props.totalCount,
    fileName: dateVal
  })));
};

export default RiskFilter;